interface AdminDashboardHeaderProps {
  panelTitle?: string;
}

export function AdminDashboardHeader({
  panelTitle = "Team Operations Control",
}: AdminDashboardHeaderProps) {
  return (
    <header className="flex flex-col gap-2">
      <div>
        <p className="text-xs uppercase tracking-[0.32em] text-ink-500">
          Admin Console
        </p>
        <h1 className="font-display text-3xl text-ink-900 md:text-4xl">
          {panelTitle}
        </h1>
      </div>
    </header>
  );
}
